import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Story } from '@models';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-story-modal',
  templateUrl: './story-modal.component.html',
  styleUrls: ['./story-modal.component.scss'],
  standalone: false,
})
export class StoryModalComponent implements OnInit {
  @Input() story: Story;

  constructor(
    public activeModal: NgbActiveModal,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {}
}
